
var Menu = function() {
    var currentScrollTop = 0;

    $(document).ready(function() {
        var scrollBarWidth = getScrollbarWidth();

        // Collapse menu
        $('.navbar-custom-collapse').on('show.bs.collapse', function(e) {
            $('.navbar-search').collapse('hide');
            $('.navbar-toggle').addClass('active');

            // Het menu kan hoger zijn dan het scherm. In dat geval de huidige
            // scrolltop opslaan en de body overflow hidden geven.
            setScrollTop();
            setTimeout(function() {
                $('body').addClass('scroll-disabled');
                $('.navbar-fixed-top').css('margin-right', scrollBarWidth);
            }, 300);
        });
        $('.navbar-custom-collapse').on('hide.bs.collapse', function(e) {
            $('.navbar-toggle').removeClass('active');

            // Bij het sluiten van het menu de body weer overflow scroll geven
            // en de opgeslagen scrolltop laden.
            $('body').removeClass('scroll-disabled');
            $('.navbar-fixed-top').css('margin-right', 0);
            window.scrollTop = currentScrollTop;
        });

        // Collapse search
        $('.navbar-search').on('show.bs.collapse', function() {
            $('.navbar-custom-collapse').collapse('hide');
            $('.navbar-search-toggle').addClass('active');

            setTimeout(function() {
                $('.navbar-search .form-control').focus();
            }, 500);
        });
        $('.navbar-search').on('hide.bs.collapse', function() {
            $('.navbar-search-toggle').removeClass('active');
            $('body').removeClass('scroll-disabled');
            window.scrollTop = currentScrollTop;
        });

        // Popin dropdown menus
        $('a[data-target-popin-menu]').on('click', function(e) {
            e.stopPropagation();
            e.preventDefault();

            if ($(this).hasClass('disabled')) {
                return;
            }

            var showContainer = $(this).data('target-popin-menu');
            $('.nav-popin-menu').not(showContainer).removeClass('active');

            if ($(showContainer).hasClass('active')) {
                $(showContainer).removeClass('active');

            } else {
                $(showContainer).addClass('active');
                $(window).trigger('resize-popin-menu');
            }
        });
        $(document).on('click', function(e) {
            $('.nav-popin-menu').removeClass('active');
        });
        $('.nav-popin-menu').on('click', function(e) {
            // e.stopPropagation();
        });
        $(window).on('resize resize-popin-menu', function() {
            $('a[data-target-popin-menu]').each(function() {
                var $target = $($(this).data('target-popin-menu'));

                if (!$target.hasClass('active')) {
                    return;
                }

                var positionType = 'left';
                var position     = $(this).position().left;

                if ($target.hasClass('message-actions')) {
                    // quickfix voor presentatie
                    position -= 140;
                }

                if ($(window).width() < 768) {
                	positionType = 'right';
                	position     = -10;
                }

                $target.css('top', $(this).position().top + $(this).height()).css(positionType, position);
            });
        });
    });

    $(document).keyup(function(e) {
        if (e.keyCode == 27) {
            $('.navbar-top .icon-button[data-toggle="collapse"].active').click();
        }
    });

    var setScrollTop = function() {
        currentScrollTop = window.scrollTop;
    };

    var getScrollbarWidth = function() {
        var $div = $('<div />').css({
            width: '100px',
            height: '100px',
            overflow: 'scroll',
            position: 'absolute',
            top: '-9999px',
        }).appendTo($('body'));

        var scrollbarWidth = $div.get(0).offsetWidth - $div.get(0).clientWidth;
        $div.remove();

        return scrollbarWidth;
    };
}();
